import { useRouter } from 'next/router'
import { t } from '../../../utils'
import {
  labCommunityPath,
  labEventsPath,
  labTrainingPath
} from '../../../utils/routeHelpers'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faTimes,
  faChevronRight,
  faCalendarDays
} from '@fortawesome/free-solid-svg-icons'
import styles from './_congratsModal.module.scss'

interface CongratsModalProps {
  closeModal: () => void
}

const CongratsModal: React.FC<CongratsModalProps> = ({ closeModal }) => {
  const router = useRouter()

  return (
    <div className={styles.overlay} onClick={closeModal}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className={styles.closeButton}
          onClick={closeModal}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>

        <h2 className={styles.title}>
          <span className={styles.titleIcon} aria-hidden>
            {'\u{1F389}'}
          </span>
          {t('Congrats!')}
        </h2>

        <p className={styles.body}>
          {t("You've completed your setup and unlocked ")}
          <span className={styles.highlight}>{t('everything')}</span>
          {t(' inside')}
        </p>

        <div className={styles.actions}>
          <button
            type="button"
            className={styles.primaryButton}
            onClick={() => {
              closeModal()
              router.push(labTrainingPath())
            }}
          >
            {t('Explore Your Next Training')}
          </button>
          <button
            type="button"
            className={styles.secondaryButton}
            onClick={() => {
              closeModal()
              router.push(labCommunityPath())
            }}
          >
            <span className={styles.secondaryButtonText}>
              {t('Jump Into The Community')}
            </span>
            <span className={styles.chevron}>
              <FontAwesomeIcon icon={faChevronRight} />
            </span>
          </button>
        </div>

        <button
          type="button"
          className={styles.calendarLink}
          onClick={() => {
            closeModal()
            router.push(labEventsPath())
          }}
        >
          <FontAwesomeIcon
            icon={faCalendarDays}
            className={styles.calendarIcon}
          />
          {t('Or, browse upcoming events on the Calendar')}
        </button>
      </div>
    </div>
  )
}

export default CongratsModal
